import React from "react";

const CashContext = React.createContext();

export default CashContext;
